module.exports = __webpack_public_path__ + "img/z-other_Rectangle 5.7bd96cbc.svg";